<template>
  <div class="py-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
    <header class="text-center mb-16">
      <h1 class="text-4xl font-extrabold text-gray-900 sm:text-5xl">
        Lleva tu experiencia al <span class="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">Nivel Premium</span>
      </h1>
      <p class="mt-4 text-xl text-gray-500">Chatea sin límites con todas nuestras chicas de Nicaragua.</p>
    </header>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
      <div v-for="benefit in benefits" :key="benefit.title" class="bg-white p-8 rounded-[2rem] shadow-sm border border-gray-100 text-center flex flex-col items-center">
        <div class="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-purple-100 text-purple-600 mb-4">
          <component :is="benefit.iconComponent" class="w-6 h-6" />
        </div>
        <h3 class="text-lg font-bold text-gray-900">{{ benefit.title }}</h3>
        <p class="mt-2 text-gray-500 text-sm">{{ benefit.description }}</p>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
      <div class="bg-white p-8 rounded-[2rem] border border-gray-200 shadow-sm flex flex-col">
        <h3 class="text-xl font-bold text-gray-900">Plan Básico</h3>
        <p class="text-gray-500 text-sm mb-6">Para empezar a descubrir.</p>
        <div class="text-4xl font-black text-gray-900 mb-6">$0 <span class="text-sm text-gray-400 font-normal">/ siempre</span></div>

        <ul class="space-y-4 mb-8 flex-grow">
          <li class="flex items-center text-gray-600 text-sm">
            <svg class="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path></svg>
            Chatea con 3 modelos básicas
          </li>
          <li class="flex items-center text-gray-400 text-sm line-through">
            <svg class="w-5 h-5 text-gray-300 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            Modelos exclusivas (Premium)
          </li>
          <li class="flex items-center text-gray-400 text-sm line-through">
            <svg class="w-5 h-5 text-gray-300 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            Mensajes ilimitados
          </li>
        </ul>

        <button disabled class="w-full py-3 rounded-full font-bold bg-gray-100 text-gray-400">Tu plan actual</button>
      </div>

      <div class="relative bg-white p-8 rounded-[2rem] border-2 border-purple-500 shadow-xl flex flex-col transform md:scale-105">
        <div class="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
          Recomendado
        </div>

        <h3 class="text-xl font-bold text-gray-900">VIP Premium</h3>
        <p class="text-gray-500 text-sm mb-6">Acceso total sin restricciones.</p>
        <div class="text-4xl font-black text-gray-900 mb-6">$9.99 <span class="text-sm text-gray-400 font-normal">/ mes</span></div>

        <ul class="space-y-4 mb-8 flex-grow">
          <li v-for="item in premiumFeatures" :key="item" class="flex items-center text-gray-600 text-sm font-medium">
            <svg class="w-5 h-5 text-purple-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path></svg>
            {{ item }}
          </li>
        </ul>

        <button @click="handleSubscribe" class="w-full py-3 rounded-full font-bold bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-transform shadow-lg">
          Suscribirme Ahora
        </button>
      </div>
    </div>

    <div class="mt-16 text-center text-gray-400 text-xs">
      <p class="flex items-center justify-center gap-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
        Pagos seguros y encriptados. Cancela cuando quieras.
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, h } from 'vue'
import Swal from 'sweetalert2'

// Definición de iconos SVG como componentes funcionales para evitar dependencias externas
const IconInfinity = () => h('svg', { fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', strokeWidth: '2' }, [h('path', { d: 'M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632-3.368m-6.632 3.368a3 3 0 006.632-3.368m0 0a3 3 0 110 2.684m0-2.684l-6.632 3.368m6.632-3.368a3 3 0 01-6.632 3.368' })])
const IconStar = () => h('svg', { fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', strokeWidth: '2' }, [h('path', { d: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.382-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z' })])
const IconShield = () => h('svg', { fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', strokeWidth: '2' }, [h('path', { d: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' })])

const benefits = ref([
  {
    title: 'Sin Límites',
    description: 'Envía todos los mensajes que quieras sin restricciones de tiempo.',
    iconComponent: IconInfinity
  },
  {
    title: 'Contenido Exclusivo',
    description: 'Accede a mujeres de Estelí, León, Chinandega y Managua que nadie más puede ver.',
    iconComponent: IconStar
  },
  {
    title: 'Privacidad Total',
    description: 'Tus conversaciones están protegidas con encriptación de extremo a extremo.',
    iconComponent: IconShield
  }
])

const premiumFeatures = [
  '+50 Mujeres de toda Nicaragua',
  'Mensajes de chat ilimitados',
  'Ver fotos exclusivas y privadas',
  'Soporte prioritario 24/7'
]

const handleSubscribe = () => {
  Swal.fire({
    title: '¡Casi eres Premium!',
    text: 'Estamos conectando con la pasarela de pago segura...',
    icon: 'info',
    showConfirmButton: false,
    timer: 2000
  }).then(() => {
    window.location.href = 'https://www.paypal.com/ncp/payment/FHEYVPLANKRCJ'
  })
}
</script>